import { render, staticRenderFns } from "./paymentHistory.vue?vue&type=template&id=d70311f2&scoped=true&"
import script from "./paymentHistory.vue?vue&type=script&lang=js&"
export * from "./paymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./paymentHistory.vue?vue&type=style&index=0&id=d70311f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70311f2",
  null
  
)

export default component.exports